import React, {Fragment, useRef, useState} from 'react';
import AddIcon from '@material-ui/icons/Add';
import {useTheme} from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import { Field} from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import {Form, Popup, Select, Accordion, Radio, MultipleSelect, Chip_input, Explanation_text, Date_picker} from '../../../../../../../components';
import AddressSection from '../../../../../../../components/FormSections/Fields/AddressSection'
import DescriptionSection from '../../../../../../../components/FormSections/Fields/DescriptionSection'
import ExtraUrlsSection from '../../../../../../../components/FormSections/Fields/ExtraUrlsSection'
import CustomFieldsSection from '../../../../../../../components/FormSections/Fields/CustomFieldsSection'
import CustomDecisionsSection from '../../../../../../../components/FormSections/Fields/CompanyDecisionsSection';
import SelectListSection from '../../../../../../../components/FormSections/Fields/SelectListSection';
import ForwardIcon from '@material-ui/icons/Forward';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ImageIcon from '@material-ui/icons/Image';
import CancelIcon from '@material-ui/icons/Cancel';
import Button from '@material-ui/core/Button';
import Draggable from 'react-draggable';
import axios from 'axios';


export default function Edit_popup_form(props){
  const [open_section, setOpenSection]=useState(undefined);
  let initial_values=useRef(undefined);
  let first_time=useRef(true);
  const theme=useTheme();

  function setClosed(){
    props.handleClose();
    first_time.current=false;
  }

  if(props.workspace_data==undefined){return (null);}

  function onSubmit(params){
    if(params.delete!=undefined){delete params.delete;}
    let send_params=JSON.parse(JSON.stringify(params));
    for(let key of ['name', 'address', 'city', 'region', 'postal_code', 'website']){if(send_params[key]==undefined || send_params[key]==''){send_params[key]='NULL';}}
    delete send_params.timeline_items;
    for(let key in send_params){if(key.includes('company_decision_') && send_params[key]!==''){if(send_params.company_decisions==undefined){send_params.company_decisions=[];} send_params.company_decisions.push({value:send_params[key], workspace_decision_id:key.replace('company_decision_', '')});}}
    props.updateCompany(params.id, send_params, props.company);
    first_time.current=true;
   }

  let owners=[{id:'NONE', name:'No owner'}];

  if(props.workspace_data!=undefined){let us=props.workspace_data.all_user_workspaces; for(let key in us){if(us[key].invisible!=true){owners.push({id:us[key].id, name:us[key].first_name+' '+us[key].last_name})}}}

  let initial_data=JSON.parse(JSON.stringify(props.company));
  initial_data.website=initial_data.actual_website;
  if(initial_data.company_listing_websites!=undefined){
    for(let clw of initial_data.company_listing_websites){
      initial_data.company_urls.push({...clw, listing_website:true, url:clw.website});
    }
  }
  if(initial_data.company_decisions!=undefined){for(let cd of initial_data.company_decisions){initial_data['company_decision_'+cd.workspace_decision_id]=cd.value;}}
  if(first_time.current==true){first_time.current=false; initial_values.current=initial_data;}
  return(
    <Form
      onSubmit={onSubmit}
      initialValues={initial_values.current}
      keepDirtyOnReinitializef
      handleClose={()=>{setClosed(true);}}
      mutators={{
        ...arrayMutators
      }}
    >

      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
          <Popup icon={(props.company.icon==undefined)?undefined:<img src={props.company.icon} style={{width:'50px', marginLeft:'-10px', marginTop:'-5px'}}/>} title='prospect_prospect_update_popup_title' align='right' always_open accept_button_click={()=>{form_props.form.submit();}} closed={()=>{form_props.form.setConfig('keepDirtyOnReinitialize', false); form_props.form.reset(); form_props.form.setConfig('keepDirtyOnReinitialize', true); setClosed(true);}} content={(closed==true)?null:
                  <div style={{minHeight:'500px'}}>
                    <Grid container style={{marginTop:'20px', marginBottom:'20px', marginLeft:'20px', width:'calc(100% - 40px)', position:'relative'}}>
                    <SelectListSection {...props} remove_new_list/>
                    <Grid item xs={6} sm={4}><Select size='small' variant='outlined' title='prospect_owner_label' name='user_workspace_id'style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'10px', backgroundColor:'#f7f9fc'}} select_data={owners}/></Grid>
                    <Grid item xs={6} sm={4}><Field name='name'>{(f)=><TextField size='small' variant='outlined' label='Company name' value={f.input.value} onChange={f.input.onChange} style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'10px', backgroundColor:'#f7f9fc'}} />}</Field></Grid>
                    <Grid item xs={6} sm={4}><Select title='prospect_status_label' name='status' style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'10px', backgroundColor:'#f7f9fc'}}  enum='status'/></Grid>
                    <Grid item xs={6} sm={4}><Field name='website'>{(f)=><TextField size='small' variant='outlined' label='Website' value={f.input.value} onChange={f.input.onChange} style={{width:'calc(100% - 20px)', marginLeft:'10px', marginTop:'10px', backgroundColor:'#f7f9fc'}} />}</Field></Grid>

                    <Grid item xs={12}><hr style={{width:'100%', marginTop:'20px',marginBottom:'0px'}}/></Grid>
                    <AddressSection {...props} open_section={open_section} setOpenSection={setOpenSection}/>
                    <DescriptionSection {...props} open_section={open_section} setOpenSection={setOpenSection}/>
                    <ExtraUrlsSection {...props} open_section={open_section} setOpenSection={setOpenSection} type="COMPANY"/>
                    <CustomFieldsSection {...props}  open_section={open_section} setOpenSection={setOpenSection} type="COMPANY"/>
                    <CustomDecisionsSection {...props} open_section={open_section} setOpenSection={setOpenSection}/>
                  </Grid>
                  </div>
          } button_variant='icon_button' onOpen={()=>{setClosed(false);}} accept_button='Save'/>
        </form>
      )}
    </Form>
  )
}


//return(<Fragment><span><IconButton>{props.icons[c]}</IconButton></span><span><TextField size='small' variant='outlined' style={{width:'calc(100% - 60px)', backgroundColor:'#f7f9fc'}} label={c} onChange={(e)=>{let v=e.target.value; let new_val=f.input.value; new_val.push({company_url_type_id:index, url:v}); f.input.onChange(''); f.input.onChange(new_val)}}/></span></Fragment>)


function selectIndex(options, value){for(let o of options){if(o.name==value){return o.id;}}}

//function valueOfField(f, workspace_field_id){
//  for(let v of f.input.value){
//    if(v.workspace_field_id==workspace_field_id){return v.value;}
//  }
//  return '';
//}
